import { render, staticRenderFns } from "./OptOut.vue?vue&type=template&id=12746afa&scoped=true&"
import script from "./OptOut.vue?vue&type=script&lang=js&"
export * from "./OptOut.vue?vue&type=script&lang=js&"
import style0 from "./OptOut.vue?vue&type=style&index=0&id=12746afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12746afa",
  null
  
)

export default component.exports